export enum FriendshipStatus {
  Pending = "Pending",
  Approved = "Approved",
  Denied = "Denied",
}

export interface FriendProfile {
  id: number;
  username?: string;
  name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  displayName?: string;
  pp_points?: number;
  profile_image?: string;
  [key: string]: any;
}

export interface Friendship {
  user_id: number;
  friend_id: number;
  status: FriendshipStatus;
  created_at: string;
  friend?: FriendProfile | null;
  user?: FriendProfile | null;
}

export type CreateFriendshipPayload = Pick<
  Friendship,
  "user_id" | "friend_id" | "status" | "created_at"
>;
